const { logger } = require(SERVER ? "./server" : "./client");

export default logger;
